/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type PROJECT_STATUS = "DONE" | "HALTED" | "OPPORTUNITY" | "PLANNING" | "RUNNING" | "%future added value";
export type UpdateTimeRegInput = {
    id?: string | null | undefined;
    ids?: Array<string | null> | null | undefined;
    updateTimeRegLocation?: boolean | null | undefined;
    taskId?: string | null | undefined;
    idleTimeId?: string | null | undefined;
    projectId?: string | null | undefined;
    roleId?: string | null | undefined;
    year?: number | null | undefined;
    month?: number | null | undefined;
    day?: number | null | undefined;
    minutesRegistered?: number | null | undefined;
    billableMinutesRegistered?: number | null | undefined;
    retainerConflictHandled?: boolean | null | undefined;
    removeOthersForTheDay?: boolean | null | undefined;
    notes?: string | null | undefined;
    harvestTaskId?: string | null | undefined;
    retryHarvest?: boolean | null | undefined;
    unit4ActivityId?: string | null | undefined;
    unit4ActivityName?: string | null | undefined;
    skipApprovalValidation?: boolean | null | undefined;
    overrideInvoiced?: boolean | null | undefined;
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type updateTimeRegistrationMutationModernMutationVariables = {
    input: UpdateTimeRegInput;
};
export type updateTimeRegistrationMutationModernMutationResponse = {
    readonly updateTimeReg: {
        readonly timeReg: {
            readonly id: string;
            readonly day: number | null;
            readonly month: number | null;
            readonly year: number | null;
            readonly canvasTimelineDate: number | null;
            readonly minutesRegistered: number | null;
            readonly billableMinutesRegistered: number | null;
            readonly role: {
                readonly id: string;
                readonly name: string | null;
            } | null;
            readonly notes: string | null;
            readonly invoiced: boolean | null;
            readonly xeroInvoiceId: string | null;
            readonly lockedInPeriod: boolean | null;
            readonly harvestTimeId: number | null;
            readonly allocationId: string | null;
            readonly harvestTask: {
                readonly id: string;
                readonly name: string | null;
            } | null;
            readonly harvestTaskIdInt: number | null;
            readonly harvestError: string | null;
            readonly unit4ActivityId: string | null;
            readonly unit4ActivityName: string | null;
            readonly project: {
                readonly id: string;
                readonly name: string | null;
                readonly status: PROJECT_STATUS | null;
                readonly projectColor: string | null;
                readonly companyProjectId: number | null;
                readonly estimationUnit: string | null;
                readonly fullAccessToProject: boolean | null;
                readonly harvestProject: {
                    readonly id: string;
                    readonly name: string | null;
                } | null;
                readonly unit4Project: {
                    readonly id: string;
                    readonly name: string | null;
                } | null;
                readonly client: {
                    readonly id: string;
                    readonly name: string | null;
                } | null;
            } | null;
            readonly task: {
                readonly id: string;
                readonly name: string | null;
                readonly progress: number | null;
                readonly companyTaskId: number | null;
                readonly highPriority: boolean | null;
                readonly approved: boolean | null;
                readonly favoured: boolean | null;
                readonly fullAccessToProject: boolean | null;
                readonly latestUiUpdateAt: string | null;
                readonly timeLeft: number | null;
                readonly timeLeftMinutesWithoutFutureTimeRegs: number | null;
                readonly totalMinutesRegistered: number | null;
                readonly project: {
                    readonly id: string;
                    readonly name: string | null;
                    readonly status: PROJECT_STATUS | null;
                    readonly companyProjectId: number | null;
                    readonly projectColor: string | null;
                    readonly estimationUnit: string | null;
                    readonly fullAccessToProject: boolean | null;
                    readonly client: {
                        readonly id: string;
                        readonly name: string | null;
                    } | null;
                    readonly harvestProject: {
                        readonly id: string;
                        readonly name: string | null;
                    } | null;
                    readonly unit4Project: {
                        readonly id: string;
                        readonly name: string | null;
                    } | null;
                } | null;
                readonly phase: {
                    readonly id: string;
                    readonly name: string | null;
                } | null;
            } | null;
            readonly idleTime: {
                readonly id: string;
                readonly name: string | null;
                readonly isInternalTime: boolean | null;
                readonly favoured: boolean | null;
            } | null;
            readonly person: {
                readonly id: string;
                readonly firstName: string | null;
                readonly lastName: string | null;
                readonly isViewer: boolean | null;
            } | null;
        } | null;
        readonly deletedTimeRegIds: ReadonlyArray<string | null> | null;
        readonly task: {
            readonly timeLeft: number | null;
            readonly totalMinutesRegistered: number | null;
            readonly currentPrice: number | null;
            readonly allTotalTimeAndExpensesAtCompletion: number | null;
            readonly progress: number | null;
        } | null;
        readonly errors: ReadonlyArray<string | null> | null;
    } | null;
};
export type updateTimeRegistrationMutationModernMutation = {
    readonly response: updateTimeRegistrationMutationModernMutationResponse;
    readonly variables: updateTimeRegistrationMutationModernMutationVariables;
};



/*
mutation updateTimeRegistrationMutationModernMutation(
  $input: UpdateTimeRegInput!
) {
  updateTimeReg(input: $input) {
    timeReg {
      id
      day
      month
      year
      canvasTimelineDate
      minutesRegistered
      billableMinutesRegistered
      role {
        id
        name
      }
      notes
      invoiced
      xeroInvoiceId
      lockedInPeriod
      harvestTimeId
      allocationId
      harvestTask {
        id
        name
      }
      harvestTaskIdInt
      harvestError
      unit4ActivityId
      unit4ActivityName
      project {
        id
        name
        status
        projectColor
        companyProjectId
        estimationUnit
        fullAccessToProject
        harvestProject {
          id
          name
        }
        unit4Project {
          id
          name
        }
        client {
          id
          name
        }
      }
      task {
        id
        name
        progress
        companyTaskId
        highPriority
        approved
        favoured
        fullAccessToProject
        latestUiUpdateAt
        timeLeft
        timeLeftMinutesWithoutFutureTimeRegs
        totalMinutesRegistered
        project {
          id
          name
          status
          companyProjectId
          projectColor
          estimationUnit
          fullAccessToProject
          client {
            id
            name
          }
          harvestProject {
            id
            name
          }
          unit4Project {
            id
            name
          }
        }
        phase {
          id
          name
        }
      }
      idleTime {
        id
        name
        isInternalTime
        favoured
      }
      person {
        id
        firstName
        lastName
        isViewer
      }
    }
    deletedTimeRegIds
    task {
      timeLeft
      totalMinutesRegistered
      currentPrice
      allTotalTimeAndExpensesAtCompletion
      progress
      id
    }
    errors
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateTimeRegInput!"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = [
  (v2/*: any*/),
  (v3/*: any*/)
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectColor",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "companyProjectId",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "estimationUnit",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullAccessToProject",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "HarvestProjectType",
  "kind": "LinkedField",
  "name": "harvestProject",
  "plural": false,
  "selections": (v4/*: any*/),
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "concreteType": "Unit4ProjectType",
  "kind": "LinkedField",
  "name": "unit4Project",
  "plural": false,
  "selections": (v4/*: any*/),
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "concreteType": "Client",
  "kind": "LinkedField",
  "name": "client",
  "plural": false,
  "selections": (v4/*: any*/),
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "progress",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "favoured",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "timeLeft",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalMinutesRegistered",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "concreteType": "TimeRegType",
  "kind": "LinkedField",
  "name": "timeReg",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "day",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "month",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "year",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "canvasTimelineDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "minutesRegistered",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "billableMinutesRegistered",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Role",
      "kind": "LinkedField",
      "name": "role",
      "plural": false,
      "selections": (v4/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "notes",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "invoiced",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "xeroInvoiceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lockedInPeriod",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "harvestTimeId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "allocationId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "HarvestTaskType",
      "kind": "LinkedField",
      "name": "harvestTask",
      "plural": false,
      "selections": (v4/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "harvestTaskIdInt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "harvestError",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "unit4ActivityId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "unit4ActivityName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ProjectType",
      "kind": "LinkedField",
      "name": "project",
      "plural": false,
      "selections": [
        (v2/*: any*/),
        (v3/*: any*/),
        (v5/*: any*/),
        (v6/*: any*/),
        (v7/*: any*/),
        (v8/*: any*/),
        (v9/*: any*/),
        (v10/*: any*/),
        (v11/*: any*/),
        (v12/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Task",
      "kind": "LinkedField",
      "name": "task",
      "plural": false,
      "selections": [
        (v2/*: any*/),
        (v3/*: any*/),
        (v13/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "companyTaskId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "highPriority",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "approved",
          "storageKey": null
        },
        (v14/*: any*/),
        (v9/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "latestUiUpdateAt",
          "storageKey": null
        },
        (v15/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "timeLeftMinutesWithoutFutureTimeRegs",
          "storageKey": null
        },
        (v16/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "ProjectType",
          "kind": "LinkedField",
          "name": "project",
          "plural": false,
          "selections": [
            (v2/*: any*/),
            (v3/*: any*/),
            (v5/*: any*/),
            (v7/*: any*/),
            (v6/*: any*/),
            (v8/*: any*/),
            (v9/*: any*/),
            (v12/*: any*/),
            (v10/*: any*/),
            (v11/*: any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PhaseType",
          "kind": "LinkedField",
          "name": "phase",
          "plural": false,
          "selections": (v4/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "IdleTime",
      "kind": "LinkedField",
      "name": "idleTime",
      "plural": false,
      "selections": [
        (v2/*: any*/),
        (v3/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isInternalTime",
          "storageKey": null
        },
        (v14/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Person",
      "kind": "LinkedField",
      "name": "person",
      "plural": false,
      "selections": [
        (v2/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "firstName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lastName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isViewer",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deletedTimeRegIds",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currentPrice",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "allTotalTimeAndExpensesAtCompletion",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "errors",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "updateTimeRegistrationMutationModernMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateTimeRegPayload",
        "kind": "LinkedField",
        "name": "updateTimeReg",
        "plural": false,
        "selections": [
          (v17/*: any*/),
          (v18/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Task",
            "kind": "LinkedField",
            "name": "task",
            "plural": false,
            "selections": [
              (v15/*: any*/),
              (v16/*: any*/),
              (v19/*: any*/),
              (v20/*: any*/),
              (v13/*: any*/)
            ],
            "storageKey": null
          },
          (v21/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "updateTimeRegistrationMutationModernMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateTimeRegPayload",
        "kind": "LinkedField",
        "name": "updateTimeReg",
        "plural": false,
        "selections": [
          (v17/*: any*/),
          (v18/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Task",
            "kind": "LinkedField",
            "name": "task",
            "plural": false,
            "selections": [
              (v15/*: any*/),
              (v16/*: any*/),
              (v19/*: any*/),
              (v20/*: any*/),
              (v13/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          (v21/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "updateTimeRegistrationMutationModernMutation",
    "operationKind": "mutation",
    "text": "mutation updateTimeRegistrationMutationModernMutation(\n  $input: UpdateTimeRegInput!\n) {\n  updateTimeReg(input: $input) {\n    timeReg {\n      id\n      day\n      month\n      year\n      canvasTimelineDate\n      minutesRegistered\n      billableMinutesRegistered\n      role {\n        id\n        name\n      }\n      notes\n      invoiced\n      xeroInvoiceId\n      lockedInPeriod\n      harvestTimeId\n      allocationId\n      harvestTask {\n        id\n        name\n      }\n      harvestTaskIdInt\n      harvestError\n      unit4ActivityId\n      unit4ActivityName\n      project {\n        id\n        name\n        status\n        projectColor\n        companyProjectId\n        estimationUnit\n        fullAccessToProject\n        harvestProject {\n          id\n          name\n        }\n        unit4Project {\n          id\n          name\n        }\n        client {\n          id\n          name\n        }\n      }\n      task {\n        id\n        name\n        progress\n        companyTaskId\n        highPriority\n        approved\n        favoured\n        fullAccessToProject\n        latestUiUpdateAt\n        timeLeft\n        timeLeftMinutesWithoutFutureTimeRegs\n        totalMinutesRegistered\n        project {\n          id\n          name\n          status\n          companyProjectId\n          projectColor\n          estimationUnit\n          fullAccessToProject\n          client {\n            id\n            name\n          }\n          harvestProject {\n            id\n            name\n          }\n          unit4Project {\n            id\n            name\n          }\n        }\n        phase {\n          id\n          name\n        }\n      }\n      idleTime {\n        id\n        name\n        isInternalTime\n        favoured\n      }\n      person {\n        id\n        firstName\n        lastName\n        isViewer\n      }\n    }\n    deletedTimeRegIds\n    task {\n      timeLeft\n      totalMinutesRegistered\n      currentPrice\n      allTotalTimeAndExpensesAtCompletion\n      progress\n      id\n    }\n    errors\n  }\n}\n"
  }
};
})();
(node as any).hash = '838316882824a4325f609bafe3fea6d1';
export default node;
